import { NDR_SHIPMENT_FAILURE, NDR_SHIPMENT_REQUEST, NDR_SHIPMENT_RESET, NDR_SHIPMENT_SUCCESS } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const shipmentNdrReducer = (state = initialState, action) => {
    switch (action.type) {
        case NDR_SHIPMENT_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case NDR_SHIPMENT_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case NDR_SHIPMENT_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case NDR_SHIPMENT_RESET:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: null });
        default:
            return state;
    }
};
export default shipmentNdrReducer;
